import { useMemo } from 'react';

import { TypographyStylesProvider } from '@mantine/core';

import { Marked } from '@ts-stack/markdown';
import DOMPurify from 'dompurify';

import classes from './MarkdownParser.module.css';

/**
 * Markdown as HTML that is safe to put on the page.
 *
 * The markdown library passes raw HTML through unchanged, and report content
 * can quote text the platform did not write (a flagged social media post, a
 * provider's record), so its output is sanitised: scripts, event handlers and
 * `javascript:` links are removed, while headings, tables, lists, quotations,
 * links and images stay.
 */
export function renderMarkdown(content: string): string {
  return DOMPurify.sanitize(Marked.parse(content));
}

export function MarkdownParser({ content }: { content: string }) {
  const html = useMemo(() => renderMarkdown(content), [content]);
  return (
    <TypographyStylesProvider>
      <div dangerouslySetInnerHTML={{ __html: html }} className={classes.markdownContent} />
    </TypographyStylesProvider>
  );
}
